


import SECTION_1676449885066 from
'../dynamic_section/dynamic_2/template_01';






import ShoppingCart from '../sections/shopping_cart/template_01';







import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const PromotionPage = ()=>{
return (
  <div id="promotionPage" class="page ">
  
  

{/*   
  < SECTION_1676449885066 desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `promo_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
   */}
  
  
  

  
  <ShoppingCart desktopTitleToggle={ false }
    mobileTitleToggle={ true } />
  
  
  
  


  
  

  
  {/* < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
   */}
  
  
</div>
)
}

export default PromotionPage;